<template>
    <div class="twoBannerHome wow fadeInAnimated fadeIn">
        <div class="title">
            <img :src="haojobLogo" alt="" @click="goHome" style="cursor:pointer;">
            <ul class="tabItem">
                <li @click="goHome">首页</li>
                <li @click="$router.push('/investment')">招商加盟</li>
                <li @mouseenter="appDownload"  @mouseleave="leaveDownload" :class="appTrueActive?'active':''">APP下载</li>
                <li @click="$router.push('/relationPages')">联系我们</li>
                <li style="width: 100px;height: 35px;background: #FFFFFF;border: 1px solid #1D5EEA;line-height:35px;text-align: center;margin-top:22.5px;padding:0;"><a style="color:#1D5EEA;text-decoration: none;" href="http://consoletwo.lielanghr.com/#/login">劳务登录</a></li>
            </ul>
        </div>
        <downloadApp v-if="appTrueActive"></downloadApp>
        <div class="centerFloat">
            <div class="enterWindow" v-if="maskTrue">
                <div class="maskBack"></div>
                <div class="writeCont">
                    <p class="operationArea">运营区域</p>
                    <div class="uldetailAddress">
                        <span class="uldetailAddressLi" v-for="(item,index) in groupData" :key="index"> 
                            <span class="uldetailAddressLiTitle">{{item.address}}</span>
                            <span class="uldetailAddressLiName">
                                <span v-for="(name,ind) in item.data" :key="ind">{{steetFun(name.provinces)}}</span>
                            </span>
                        </span>
                    </div>
                    <span class="closeImg" @click="closeMask">
                        <img :src="closeImg" alt="">
                    </span>
                </div>
            </div>
            <div class="header">
                <div class="headerCont">
                    <img :src="companyData.iconUrl" alt="" class="headTitBg">
                    <div class="preempt">
                        <span class="headerTitle">{{companyData.groupAbbreviationName}}</span>
                        <span class="headerName">{{companyData.groupManagerName}}  {{companyData.groupManagerPhone}}</span>
                        <span class="headerAdrees">{{companyData.provinces.replace(/\s+/g,"")}}{{companyData.address}}</span>
                    </div>
                    <div class="rightAddress" v-if="groupData.length>0">
                        <img :src="operationarea_bg" alt="" class="operationareaBg">
                        <div class="vessel">
                            <p class="operationArea">运营区域</p>
                            <div class="uldetailAddress">
                                <span class="uldetailAddressLi" v-for="(item,index) in groupData" :key="index"> 
                                    <span class="uldetailAddressLiTitle">{{item.address}}</span>
                                    <span class="uldetailAddressLiName">
                                        <span v-for="(name,ind) in item.data" :key="ind">{{steetFun(name.provinces)}}</span>
                                    </span>
                                </span>
                            </div>
                            <p class="seeMoreArea" @click="seeMoreArea">查看全部></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="textCont">
               <div class="hotJobTit">
                    <span v-for="(item,index) in tabItems" :key="index" :class="index==currenIndex? 'activeTab':''" @click="tabClick(index)">{{item}}</span>
               </div>
               <div v-if="currenIndex==0" class="tabContent">
                   <ul class="jobList" v-if="jobList.length>0">
                    <li class="jobListLi" v-for="(item,index) in jobList" :key="index" @click="jobShowDetail(item.jobId)">
                        <div class="jobListLiHead"> 
                            <span class="jobListLiHeadTitle">{{item.jobName}}</span>
                            <span class="jobListLiHeadMoney" v-if="item.userHourSalary">{{item.userHourSalary}}元/小时</span>
                            <span class="jobListLiHeadMoney" v-else>{{item.userMinSalary}}-{{item.userMaxSalary}}元/月</span>
                        </div>
                        <div class="jobLiAge">{{item.jobType}} | {{item.factoryTypeName}}</div>
                        <div class="jobLiLabel">
                            <span v-for="(label,index) in JSON.parse(item.welfareTag)" :key="index">
                                {{label}}
                            </span>
                        </div>
                        <div class="jobLiFoot">
                            <span class="jobLiCom">{{item.factoryAbbreviationName}}</span>
                            <img :src="locationImg" alt="" class="jobLiLoca">
                            <span class="jobLiCity">{{addressCity(item.provinces)}}</span>
                        </div>
                    </li>
                </ul>
                <div class="nodate" v-else>
                    <img :src="nodate" alt="">
                    <p>无数据</p>
                </div>
                <div class="seeMore moreBottom" v-if="jobListTrue" @click="seeMoreJob">查看更多</div>
               </div>
            </div>
            <!-- 门店 -->
            <div class="textCont" v-if="currenIndex==1">
                <ul class="partnerList" v-if="storeData.length>0">
                    <li class="partnerListLi" v-for="(item,index) in storeData" :key="index" @mouseleave="leaveStore">
                        <span v-if="currentCodeStore!=index">
                            <img :src="item.iconUrl || headLogoBg" alt="" class="partnerListLiImg">
                            <span class="partnerOne">{{item.storeAbbreviationName}}</span>
                            <span class="partnerTwo" v-if="item.storeType==1">线上店</span>
                            <span class="partnerTwo" v-else>实体店</span>
                            <span class="partnerThree" @mouseenter="storeCodeTrue(index,item)">店长二维码</span>
                            <span class="partnerFour">
                                <span class="numLi">
                                    <span>{{item.storeUserSum}}</span>
                                    <span>专员数量</span>
                                </span>
                                <span class="numLi">
                                    <span>{{item.userSum}}</span>
                                    <span>会员数量</span>
                                </span>
                            </span>
                        </span>
                        <span v-if="currentCodeStore==index" style="display: flex;flex-direction: column;align-items: center;">
                            <img :src="'data:image/png;base64,'+storeCode" alt="" class="codeImg" :style="item.storeType!=1 ? 'margin-top:0;':'margin-top:20px;'" v-if="storeCode">
                            <span class="codeImg" v-else :style="item.storeType!=1 ? 'margin-top:0;':'margin-top:20px;'">
                                <img :src="loadingImg" style="width:32px;height:32px;" alt="">
                            </span>
                            <p class="codeWechat">微信扫一扫</p>
                            <p v-if="item.storeType!=1" style="font-size: 14px;font-weight: 400;color: #666666;line-height: 20px;padding:0 30px;box-szing:border-box;word-break:break-all;
display:-webkit-box;
-webkit-box-orient:vertical;
-webkit-line-clamp:2;
overflow:hidden;">地址：{{addressCity(item.provinces)}}{{item.address}}</p>
                        </span>
                    </li>
                </ul>
                <div class="nodate" v-else>
                    <img :src="nodate" alt="">
                    <p>无数据</p>
                </div>
                <div class="seeMore moreBottom" v-if="storeSeeMore" @click="seeMoreStore">查看更多</div>
            </div>
            <div class="textCont" v-if="currenIndex==2">
                <ul class="partnerList" v-if="proxyerData.length>0">
                    <!-- @mouseover="onMousteIn(inde,index)" @mouseleave="onMousteOut()" -->
                    <li class="partnerListLi" v-for="(item,index) in proxyerData" :key="index" @mouseleave="leaveProxyer">
                        <span v-if="currentCodeProxyer!=index">
                            <img :src="item.headImgUrl || headLogoBg" alt="" class="partnerListLiImg">
                            <span class="partnerOne">{{item.name}}</span>
                            <span class="partnerTwo">隶属：{{item.storeManagerName}}</span>
                            <span class="partnerThree" @mouseenter="proxyerCodeTrue(index,item)">专员二维码</span>
                            <span class="partnerFour">
                                <span class="numLi" style="width:100%;">
                                    <span>{{item.userSum}}</span>
                                    <span>会员数量</span>
                                </span>
                            </span>
                        </span>
                        <span v-if="currentCodeProxyer==index">
                            <img :src="'data:image/png;base64,'+proxyerCode" alt="" class="codeImg" v-if="proxyerCode">
                            <span class="codeImg" v-else >
                                <img :src="loadingImg" style="width:32px;height:32px;" alt="">
                            </span>
                            <p class="codeWechat">微信扫一扫</p>
                        </span>
                    </li>
                </ul>
                <div class="nodate" v-else>
                    <img :src="nodate" alt="">
                    <p>无数据</p>
                </div>
                <div class="seeMore moreBottom" v-if="proxyerSeeMore" @click="seeMoreProxyer">查看更多</div>
            </div>
            <div class="textCont" v-if="currenIndex==3">
                <ul class="talentsList" v-if="userData.length>0"> 
                    <li class="talentsListLi" v-for="(item,index) in userData" :key="index">
                        <img :src="item.headImgUrl || logoHeader"  alt="" class="talentsListLiImg">
                        <span class="talentsRight">
                            <span class="talentsListLiName">{{item.name | userName}}</span>
                            <span class="talentsListLiNum"><span v-if="item.birthday">{{item.birthday | age}}岁 | </span>{{item.sex}}<span v-if="item.education">｜{{item.education}}</span></span>
                        </span>
                    </li>
                </ul>
                <div class="nodate" v-else>
                    <img :src="nodate" alt="">
                    <p>无数据</p>
                </div>
                <div class="seeMore moreBottom" v-if="userSeeMore" @click="seeMoreUser">查看更多</div>
            </div>
        </div>
        <footerPages :backColor="'#3A3D53'" :borderBottom="'1px solid #626475'"></footerPages>
        <div class="jobDetail" @touchmove.prevent v-if="jobDetailTrue">
            <div class="maskLayer" @click="maskClick"></div>
            <div class="jobDetailCont">
                <div class="jobDetailHead">
                    <div class="jobDetailHeadLeft">
                        <span class="comTitle">{{jobDetailData.factoryAbbreviationName}}</span>
                        <span class="jobTitle">{{jobDetailData.jobName}}</span>
                        <span class="moneyRule" v-if="jobDetailData.userHourSalary">{{jobDetailData.userHourSalary}}元/小时</span>
                        <span class="moneyRule" v-else>{{jobDetailData.userMinSalary}}-{{jobDetailData.userMaxSalary}}元/月</span>
                        <div class="ageRule">男{{jobDetailData.userManAgeMin}}～{{jobDetailData.userManAgeMax}}岁｜女{{jobDetailData.userWomanAgeMin}}～{{jobDetailData.userWomanAgeMax}}岁</div>
                        <div class="walfeLabel">
                            <span v-for="(label,index) in jobDetailData.welfareTag" :key="index">
                               {{label}}、
                           </span>
                        </div>
                    </div>
                    <div class="jobDetailHeadRight">
                        <img :src="'data:image/png;base64,'+jobCodeImg" alt="" class="img" v-if="jobCodeImg">
                        <span class="img" v-else>
                            <img :src="loadingImg" alt="" class="img" style="width:32px;height:32px;">
                        </span>
                        <span>扫码报名</span>
                    </div>
                </div>
                <div class="workAddress" v-if="jobDetailData.provinces">
                    <span class="workAddressTitle">工作地点</span>
                    <span class="workAddressDetail">{{jobDetailData.provinces.replace(/\s+/g,"")}}{{jobDetailData.address}}</span>
                </div>
                <div class="jobDescription">
                    <div class="jobDesTitle">职位描述</div>
                    <!-- 我的收入 -->
                    <div class="desList" v-if="jobDetailData.userConsolidatedIncome || jobDetailData.userSalaryStandard || jobDetailData.userGrantSalaryType || jobDetailData.userGrantSalaryTime || jobDetailData.userSalaryConstitute || jobDetailData.userSalaryConstitute || jobDetailData.userRatepayingExplain">
                    <div class="desListLabel">我的收入</div>
                    <div class="desListDev" v-if="jobDetailData.userConsolidatedIncome">
                        <div class="desListDevLeft">综合收入</div>
                        <div class="desListDevRight">{{jobDetailData.userConsolidatedIncome}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userSalaryStandard">
                        <div class="desListDevLeft">薪资标准</div>
                        <div class="desListDevRight">{{jobDetailData.userSalaryStandard}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userGrantSalaryType">
                        <div class="desListDevLeft">发薪方式</div>
                        <div class="desListDevRight" v-if="jobDetailData.userGrantSalaryType==0">按月</div>
                        <div class="desListDevRight" v-if="jobDetailData.userGrantSalaryType==1">按周</div>
                        <div class="desListDevRight" v-if="jobDetailData.userGrantSalaryType==2">按日</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userGrantSalaryTime">
                        <div class="desListDevLeft">发薪日</div>
                        <div class="desListDevRight">{{jobDetailData.userGrantSalaryTime}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userSalaryConstitute">
                        <div class="desListDevLeft">薪资结构</div>
                        <div class="desListDevRight">{{jobDetailData.userSalaryConstitute}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userRatepayingExplain">
                        <div class="desListDevLeft">纳税说明</div>
                        <div class="desListDevRight">{{jobDetailData.userRatepayingExplain}}</div>
                    </div>
                    </div>
                    <!-- 我的福利 -->
                    <div class="desList" v-if="jobDetailData.userMealsExplain || jobDetailData.userResidenceExplain || jobDetailData.userInsuranceExplain || jobDetailData.userElseWelfare">
                    <div class="desListLabel">我的福利</div>
                    <div class="desListDev" v-if="jobDetailData.userMealsExplain">
                        <div class="desListDevLeft">伙食情况</div>
                        <div class="desListDevRight">{{jobDetailData.userMealsExplain}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userResidenceExplain">
                        <div class="desListDevLeft">住宿情况</div>
                        <div class="desListDevRight">{{jobDetailData.userResidenceExplain}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userInsuranceExplain">
                        <div class="desListDevLeft">保险情况</div>
                        <div class="desListDevRight">{{jobDetailData.userInsuranceExplain}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userElseWelfare">
                        <div class="desListDevLeft">其他福利</div>
                        <div class="desListDevRight">{{jobDetailData.userElseWelfare}}</div>
                    </div>
                    </div>
                    <!-- 我的工作 -->
                    <div class="desList"  v-if="jobDetailData.userWorkContent || jobDetailData.userWorkTime || jobDetailData.userWorkType || jobDetailData.userWorkArea">
                    <div class="desListLabel">我的工作</div>
                    <div class="desListDev" v-if="jobDetailData.userWorkContent">
                        <div class="desListDevLeft">工作内容</div>
                        <div class="desListDevRight">{{jobDetailData.userWorkContent}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userWorkTime">
                        <div class="desListDevLeft">工作时间</div>
                        <div class="desListDevRight">{{jobDetailData.userWorkTime}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userWorkType">
                        <div class="desListDevLeft">工作方式</div>
                        <div class="desListDevRight">{{jobDetailData.userWorkType}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userWorkArea">
                        <div class="desListDevLeft">工作区域</div>
                        <div class="desListDevRight">{{jobDetailData.userWorkArea}}</div>
                    </div>
                    </div>
                    <!-- 录用条件 -->
                    <div class="desList" v-if="jobDetailData.userManAgeMin || jobDetailData.userEducationRequire || jobDetailData.userAreaRequire || jobDetailData.userElseRequire">
                    <div class="desListLabel">录用条件</div>
                    <div class="desListDev" v-if="jobDetailData.userManAgeMin">
                        <div class="desListDevLeft">性别年龄</div>
                        <div class="desListDevRight">男{{jobDetailData.userManAgeMin}}～{{jobDetailData.userManAgeMax}}周岁；女{{jobDetailData.userWomanAgeMin}}～{{jobDetailData.userWomanAgeMax}}周岁</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userEducationRequire">
                        <div class="desListDevLeft">学历要求</div>
                        <div class="desListDevRight" v-if="jobDetailData.userEducationRequire==0">学历不限</div>
                        <div class="desListDevRight" v-if="jobDetailData.userEducationRequire==1">小学以上</div>
                        <div class="desListDevRight" v-if="jobDetailData.userEducationRequire==2">初中以上</div>
                        <div class="desListDevRight" v-if="jobDetailData.userEducationRequire==3">高中以上</div>
                        <div class="desListDevRight" v-if="jobDetailData.userEducationRequire==4">大专以上</div>
                        <div class="desListDevRight" v-if="jobDetailData.userEducationRequire==5">本科以上</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userAreaRequire">
                        <div class="desListDevLeft">地域要求</div>
                        <div class="desListDevRight">{{jobDetailData.userAreaRequire}}</div>
                    </div>
                    <div class="desListDev" v-if="jobDetailData.userElseRequire">
                        <div class="desListDevLeft">其他要求</div>
                        <div class="desListDevRight">{{jobDetailData.userElseRequire}}</div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {WOW} from 'wowjs'
import haojobLogo from '@/assets/haoojoblogo.svg'
import contactus from '@/assets/download/contactus-map@2x.png'
import locationImg from '@/assets/location@2x.png'
import operationarea_bg from '@/assets/operationarea_bg.png'
import nodate from '@/assets/nodate.png'
import logoHeader from '@/assets/logoHeader.png'
import headLogoBg from '@/assets/headLogoBg.png'
import closeImg from '@/assets/close@3x.png'
import loadingImg from '@/assets/loadingImg.gif'

import api from '@/api'
export default {
    data(){
        return {
            loadingImg,
            appTrueActive:false,
            closeImg,
            headLogoBg,
            companyData:JSON.parse(localStorage.getItem('labourDetail')),
            logoHeader,
            nodate,
            currentCodeProxyer:-1,
            currentCodeStore:-1,
            tabItems:['招聘职位','招聘门店','招聘专员','TA的人才'],
            currenIndex:0,
            operationarea_bg,
            haojobLogo,
            contactus,
            locationImg,
            jobList: [],//职位列表
            jobListTrue:false,
            jobDetailData: [],//职位详情
            jobDetailTrue:false,
            companyList: [],//优质企业
            comSeeMore:false,
            query:{
                pageNum:1,
                pageSize:9,
                jobStatus:0
            },
     
            storeQuery:{//门店
                pageNum:1,
                pageSize:12,
            },
            storeTotalPages:'',
            storeData:[],
            storeSeeMore:false,
            
            proxyerQuery:{//专员
                pageNum:1,
                pageSize:12,
            },
            proxyerTotalPages:'',
            proxyerData:[],
            proxyerSeeMore:false,

            userQuery:{//会员
                pageNum:1,
                pageSize:16,
                isSelectStoreroom:0
            },
            userTotalPages:'',
            userData:[],
            userSeeMore:false,

            comTotalPages:'',
            jobTotalPages:'',
            jobCodeImg:'',
            proxyerCode:'',
            storeCode:'',
            groupData:[],
            maskTrue:false
        }
    },
    methods:{
        appDownload(){//移入App下载
            this.appTrueActive=true
        },
        leaveDownload(){
            this.appTrueActive=false
        },
        goHome(){
            this.$router.push('/')
        },
        seeMoreArea(){
            this.maskTrue=true
        },
        closeMask(){
            this.maskTrue=false
        },
        async getGorrelationList(){
            let query = {
                groupId:this.companyData.groupId
            }
            let data = await api.correlationList(query)
            let newGoodsList = []
            if(data.groupCityInfoListRBOList.length>0){
                let pre = {}
                let curArr = []
                for(let i in data.groupCityInfoListRBOList){
                    let cur = data.groupCityInfoListRBOList[i]
                    if (pre.code && cur.code == pre.code) {
                        curArr.push(cur)
                    }else {
                        curArr = [cur]
                        newGoodsList.push(
                            {
                                data:curArr,
                                address:curArr[0].provinces.split(' ')[0]+' '+curArr[0].provinces.split(' ')[1]+' '+curArr[0].provinces.split(' ')[2]
                            }
                        );
                        pre = cur
                    }
                }
                this.groupData = newGoodsList
            }else{
                this.groupData = []
            }
            
        },
        leaveProxyer(){
            this.currentCodeProxyer=-1
        },
        async proxyerCodeTrue(index,data){
            this.proxyerCode=''
            this.currentCodeProxyer=index
            // 获取职位二维码
            let codeQuery = {
                userId:data.userId,
                url:'pages/findJob/job'
            }
            this.proxyerCode = await api.userCode(codeQuery)
        },
        leaveStore(){
            this.currentCodeStore=-1
        },
        async storeCodeTrue(index,data){
            this.storeCode=''
            this.currentCodeStore=index
            // 获取职位二维码
            let codeQuery = {
                userId:data.storeId,
                url:'pages/findJob/job'
            }
            this.storeCode = await api.userCode(codeQuery)
        },
        tabClick(index){
            this.currenIndex = index
        },
        seeMoreStore(){//查看更多门店
            this.storeQuery.pageNum+=1
            this.getStoreListData()
        },
        seeMoreProxyer(){//查看更多专员
            this.proxyerQuery.pageNum+=1
            this.getProxyerListData()
        },
        seeMoreUser(){//查看更多会员
            this.userQuery.pageNum+=1
            this.getUserListData()
        },
        seeMoreJob(){//查看更多职位
            this.query.pageNum+=1
            this.initData()
        },
        async jobShowDetail(id){
            this.jobCodeImg=''
            // 获取职位详情
            let query = {
                jobId:id
            }
            this.jobDetailTrue = true
            let res = await api.jobInfo(query)
            res.welfareTag=JSON.parse(res.welfareTag)
            this.jobDetailData = res
            // 获取职位二维码
            let codeQuery = {
                userId:id,
                url:'pages/findJob/jobDetail/index'
            }
            this.jobCodeImg = await api.userCode(codeQuery)
        },
        async getStoreListData(){//门店数据
            this.storeQuery.groupId = this.companyData.groupId
            let res = await api.storeList(this.storeQuery)
            this.storeTotalPages = res.totalPages

            if(res.totalSize>9){//如果数据有9条以上，才显示职位更多按钮
                this.storeSeeMore=true
            }else{
                this.storeSeeMore=false
            }
            if(this.storeTotalPages==this.storeQuery.pageNum){//处理隐藏显示更多用工单位
                this.storeSeeMore = false
            }
            let obj = res.content
            this.storeData = this.storeData.concat(obj)
        },
        async getProxyerListData(){//专员shuju
            this.proxyerQuery.groupId = this.companyData.groupId
            let res = await api.proxyerList(this.proxyerQuery)
            this.proxyerTotalPages = res.totalPages

            if(res.totalSize>9){//如果数据有9条以上，才显示职位更多按钮
                this.proxyerSeeMore=true
            }else{
                this.proxyerSeeMore=false
            }
            if(this.proxyerTotalPages==this.proxyerQuery.pageNum){//处理隐藏显示更多用工单位
                this.proxyerSeeMore = false
            }
            let obj = res.content
            this.proxyerData = this.proxyerData.concat(obj)
        },
        async getUserListData(){//会员shuju
            this.userQuery.groupId = this.companyData.groupId
            let res = await api.userList(this.userQuery)
            this.userTotalPages = res.totalPages
            let obj = res.content
            for(let i=0;i<obj.length;i++){
                // 类型
                if(obj[i].education==0){
                    obj[i].education='小学'
                }else if(obj[i].education==1){
                    obj[i].education='初中'
                }else if(obj[i].education==2){
                    obj[i].education='高中'
                }else if(obj[i].education==3){
                    obj[i].education='大专'
                }else if(obj[i].education==4){
                    obj[i].education='本科'
                }else if(obj[i].education==5){
                    obj[i].education='硕士'
                }else if(obj[i].education==6){
                    obj[i].education='博士'
                }
                if(obj[i].sex==0){
                    obj[i].sex='男'
                }else if(obj[i].sex==1){
                    obj[i].sex='女'
                }
            }
            if(res.totalSize>9){//如果数据有9条以上，才显示职位更多按钮
                this.userSeeMore=true
            }else{
                this.userSeeMore=false
            }
            if(this.userTotalPages==this.userQuery.pageNum){//处理隐藏显示更多用工单位
                this.userSeeMore = false
            }
            
            this.userData = this.userData.concat(obj)
        },
        addressCity (sum) {
            if(sum){
                let city = sum.split(" ")[1]
                if(city==="市辖区" || city==="县"){
                    return sum.split(" ")[0]
                }
                return city
            }else {
                return ''
            }
        },
        maskClick(){
            this.jobDetailTrue=false
        },
        async initData(){
            this.query.groupIds = this.companyData.groupId
            let res = await api.jobList(this.query)
            this.jobTotalPages = res.totalPages
            if(res.totalSize>9){//如果数据有9条以上，才显示职位更多按钮
                this.jobListTrue=true
            }else{
                this.jobListTrue=false
            }
            if(this.jobTotalPages==this.query.pageNum){//处理隐藏显示更多用工单位
                this.jobListTrue = false
            }
            let obj = res.content
            for(let i in obj){
                if(obj[i].jobType==0){
                    obj[i].jobType='普工'
                }else if(obj[i].jobType==1){
                    obj[i].jobType='技工'
                }else if(obj[i].jobType==2){
                    obj[i].jobType='实习工'
                }
            }
            this.jobList = this.jobList.concat(obj)
        },
        
        steetFun(data){
            return data.split(' ').pop()
        },
    },
    mounted () {
        let wow = new WOW({
                boxClass: 'wow',
                animateClass: 'animated',
                offset: 0,
                mobile: true
        })
        wow.init();
    },
    created(){
        this.initData()
        this.getStoreListData()
        this.getProxyerListData()
        this.getUserListData()
        this.getGorrelationList()
        window.scrollTo(0,0);
    }
}
</script>
<style src='@/pages/components/publicStyle/animated.css' scoped></style>
<style scoped lang="less">
    .enterWindow{
        width: 100%;
        height: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 10000;
        justify-content: center;
        align-items: center;
        display: flex;
        .maskBack{
            background: rgba(0, 0, 0, 0.4);
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 99;    
        }
        
        .writeCont{
            width: 700px;
            max-width: 700px;
            background: #fff;
            position: relative;
            overflow-y: auto;
            z-index: 100;
            padding: 60px 80px;
            box-sizing: border-box;
            position: fixed;
            top: 60px;
            bottom: 60px;
            .closeImg{
                width: 40px;
                height: 40px;
                display: block;
                position: absolute;
                right: 0;
                top: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                img{
                    width: 15px;
                    height: 15px;
                    display: block;
                }
            }
            .operationArea{
                font-size: 30px;
                font-weight: 500;
                color: #222222;
                line-height: 76px;
            }
            .uldetailAddress{
                width: 100%;
                .uldetailAddressLi{
                    width: 100%;
                    height: auto;
                    overflow: hidden;
                    margin-bottom: 30px;
                    display: block;
                    .uldetailAddressLiTitle{
                        font-size: 14px;
                        font-weight: 400;
                        color: #333333;
                        display: block;
                        overflow: hidden;
                        line-height: 36px;
                    }
                    .uldetailAddressLiName>span{
                        height: 28px;
                        display: block;
                        float: left;
                        margin-right: 8px;
                        border: 1px solid #CCCCCC;
                        font-size: 14px;
                        font-weight: 400;
                        color: #666666;
                        line-height: 28px;
                        padding: 0 12px;
                        margin-bottom: 9px;
                    }
                }
            }
        }
    }
    .nodate{
        width: 100%;
        display: flex;
        height: 500px;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        img{
            width: 233px;
            height: 238px;
            display: block;
        }
        p{
            display: block;
            font-size: 16px;
            font-weight: 400;
            color: #999999;
            line-height: 48px;
        }
    }
    .jobDetail{
        width: 100%;
        min-width: 1200px;
        height: 100%;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1000;
        justify-content: center;
        display: flex;
        align-items: center;
        .maskLayer{
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 900;
            background:rgba(0, 0, 0, 0.4);
        }
        .jobDetailCont{
            width: 1000px;
            height: 600px;
            min-width: 1000px;
            overflow-y: scroll;
            margin: 0 auto;
            background: #fff;
            position: relative;
            z-index: 1001;
            overflow-x: hidden;
            .jobDetailHead{
                width: 100%;
                height: auto;
                background: #F1F6FF;
                overflow: hidden;
                padding: 50px 80px 50px 80px;
                box-sizing: border-box;
                .jobDetailHeadLeft{
                    float: left;
                    .comTitle{
                        display: block;
                        font-size: 18px;
                        color: #666;
                    }
                    .jobTitle{
                        width: 620px;
                        font-size: 36px;
                        color: #222;
                        display: block;
                        line-height: 50px;
                        margin-top: 10px;
                    }
                    .moneyRule{
                        font-size: 24px;
                        color: #F97F27;
                        display: block;
                        line-height: 32px;
                        margin-top: 5px;
                    }
                    .ageRule{
                        font-size: 18px;
                        color: #666666;
                        display: block;
                        line-height: 24px;
                        margin-top: 20px;
                    }
                    .walfeLabel{
                        font-size: 16px;
                        color: #999;
                        display: block;
                        margin-top: 10px;
                    }
                }
                .jobDetailHeadRight{
                    float: right;
                    width: 170px;
                    height: auto;
                    overflow: hidden;
                    margin-bottom: 20px;
                    .img{
                        width: 170px;
                        height: 170px;
                        display: flex;
                        background: #fff;
                        justify-content: center;
                        align-items: center;
                    }
                    span{
                        text-align: center;
                        display: block;
                        line-height: 58px;
                        font-size: 18px;
                        color: #222222;
                    }
                }
            }
            .workAddress{
                padding: 0 80px;
                width: 100%;
                height: auto;
                overflow: hidden;
                margin-top: 46px;
                .workAddressTitle{
                    font-size: 28px;
                    color: #333333;
                    font-weight: 500;
                    line-height: 32px;
                    display: block;
                }
                .workAddressDetail{
                    display: block;
                    font-size: 16px;
                    color: #666666;
                    line-height: 46px;
                    margin-top: 1px;
                    margin-bottom: 30px;
                }
            }
            .jobDescription{
                padding: 0 80px;
                box-sizing: border-box;
                overflow: hidden;
                height: auto;
                margin-bottom: 80px;
                .jobDesTitle{
                    font-weight: 500;
                    font-size: 22px;
                    margin-bottom: 20px;
                }
                .desList{
                    width: 100%;
                    height: auto;
                    overflow: hidden;
                    border: 1px solid rgba(187, 188, 204, 1);
                    border-top: 0;
                    box-sizing: border-box;
                    .desListLabel{
                        width: 99.9%;
                        height: 50px;
                        line-height: 50px;
                        background: #F2F6FF;
                        padding: 0 40px;
                        box-sizing: border-box;
                        font-size: 18px;
                        color: #1D5EEA;
                    }
                    .desListDev{
                        width: 100%;
                        height: auto;
                        overflow: hidden;
                        border-top: 1px solid rgba(187, 188, 204, 1);
                        box-sizing: border-box;
                        .desListDevLeft{
                            width: 128px;
                            float: left;
                            font-size: 16px;
                            padding: 23px 0;
                            padding-right: 40px;
                            color: #333333;
                            box-sizing: border-box;
                            text-align: right;
                        }
                        .desListDevRight{
                            width: 691px;
                            float: left;
                            border-left: 1px solid rgba(187, 188, 204, 1);
                            box-sizing: border-box;
                            font-size: 16px;
                            padding: 23px;
                            color: #565566;
                            line-height: 24px;
                            height: auto;
                            overflow: hidden;
                        }
                    }
                }
                .desList:nth-child(2){
                    border-top: 1px solid rgba(187, 188, 204, 1);
                }
            }
        }
    }
    .centerFloat{
        width: 100%;
        height: auto;
        overflow: hidden;
        box-sizing: border-box;
        .header{
            width: 100%;
            height: 220px;
            background: #F2F5FE;
            .headerCont{
                width: 1200px;
                box-sizing: border-box;
                overflow: hidden;
                margin: 0 auto;
                position: relative;
                .headTitBg{
                    width: 150px;
                    height: 150px;
                    margin-top: 35px;
                    float: left;
                    margin-right: 30px;
                }
                .preempt{
                    margin-top: 35px;
                    float: left;
                    height: 150px;
                    width: 420px;
                    display:flex;
                    justify-content: space-evenly;
                    flex-wrap: nowrap;
                    flex-direction: column;
                    overflow: hidden;
                    .headerTitle{
                        display: block;
                        font-size: 28px;
                        font-weight: 400;
                        width: 420px;
                        line-height: 30px;
                        color: #333333;
                        display: block;
                    }
                    .headerName{
                        font-size: 16px;
                        width: 100%;
                        line-height: 24px;
                        font-weight: 400;
                        color: #666666;
                        display: block;
                        display: block;
                    }
                    .headerAdrees{
                        font-size: 16px;
                        line-height: 24px;
                        width: 100%;
                        font-weight: 400;
                        color: #666666;
                        display: block;
                    }
                }
                .rightAddress{
                    width: 520px;
                    height: 180px;
                    float: right;
                    margin-top: 20px;
                    position: relative;
                    box-sizing: border-box;
                    .operationareaBg{
                       width: 520px;
                        height: 180px; 
                        position: absolute;
                        top: 0;
                        bottom: 0;
                    }
                    .vessel{
                        width: 100%;
                        height: 100%;
                        overflow: hidden;
                        padding: 25px 30px;
                        box-sizing: border-box;
                        position: relative;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-end;
                        .operationArea{
                            float: right;
                            font-size: 16px;
                            font-weight: 400;
                            color: #999999;
                            line-height: 24px;
                            display: block;
                        }
                        .uldetailAddress{
                            width: 100%;
                            height: 76px;
                            overflow: hidden;
                            margin-top: 10px;
                            position: relative;
                            .uldetailAddressLi{
                                width: 100%;
                                height: auto;
                                overflow: hidden;
                                display: flex;
                                justify-content: flex-end;
                                .uldetailAddressLiTitle{
                                    display: block;
                                    max-width: 190px;
                                    float: left;
                                    text-align: right;
                                    font-size: 14px;
                                    font-weight: 400;
                                    color: #333333;
                                    line-height: 28px;
                                    margin-right: 14px;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                }
                                .uldetailAddressLiName{
                                    max-width: 256px;
                                    height: auto;
                                    float: right;
                                    span{
                                        width: 80px;
                                        height: 28px;
                                        display: block;
                                        overflow: hidden;
                                        border: 1px solid #CCCCCC;
                                        font-size: 14px;
                                        padding: 0 10px;
                                        font-weight: 400;
                                        color: #666666;
                                        line-height: 24px;
                                        box-sizing: border-box;
                                        text-align: center;
                                        line-height: 28px;
                                        float: left;
                                        margin-left: 8px;
                                        margin-bottom: 10px;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                        overflow: hidden;
                                    }
                                    span:nth-child(3n-2){
                                        margin-left: 0;
                                    }
                                }
                            }
                        }
                        .seeMoreArea{
                            float: right;
                            font-size: 14px;
                            font-weight: 400;
                            color: #333333;
                            line-height: 24px;
                            cursor: pointer;
                            display: block;
                        }
                    }
                }
            }
        }
        .textCont{
            width: 1200px;
            height: auto;
            box-sizing: border-box;
            overflow: hidden;
            margin: 0 auto;
            .hotJobTit{
                width: auto;
                height: 30px;
                line-height: 30px;
                font-size: 16px;
                font-weight: 400;
                color: #222222;
                margin-bottom: 20px;
                margin-top: 53px;
                span{
                    float: left;
                    margin-right: 27px;
                    display: block;
                    border-bottom: 2px solid none;
                    box-sizing: border-box;
                    cursor: pointer;
                }
                .activeTab{
                    color: #1D5EEA;
                    border-bottom: 2px solid #1D5EEA;
                }
            }
            .tabContent{
                .jobList{
                    width: 100%;
                    height: auto;
                    overflow: hidden;
                    .jobListLi{
                        width: 390px;
                        height: 191px;
                        background: #fff;
                        padding: 30px;
                        box-sizing: border-box;
                        cursor: pointer;
                        float: left;
                        margin-right: 15px;
                        margin-bottom: 30px;
                        border: 1px solid rgba(204, 204, 204, 0.3);
                        .jobListLiHead{
                            width: 100%;
                            line-height: 20px;
                            font-size: 18px;
                            font-weight: 400;
                            overflow: hidden;
                            .jobListLiHeadTitle{
                                width: 140px;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                color: #222;
                                float: left;
                            }
                            .jobListLiHeadMoney{
                                color: #F97F27;
                                float: right;
                            }
                        }
                        .jobLiAge{
                            font-size: 14px;
                            color: #666;
                            margin: 14px 0;
                            width: 100%;
                        }
                        .jobLiLabel{
                            width: 100%;
                            overflow: hidden;
                            height: 30px;
                            span{
                                padding: 0 10px;
                                line-height: 28px;
                                box-sizing: border-box;
                                background: rgba(28, 129, 255, 0);
                                border: 1px solid #E5E5E5;
                                border-radius: 2px;
                                font-size: 12px;
                                color: #999999;
                                text-align: center;
                                float: left;
                                margin-right: 10px;
                            }
                        }
                        .jobLiFoot{
                            width: 100%;
                            display: block;
                            border-top: 1px dashed #E5E5E5;
                            box-sizing: border-box;
                            padding-top: 10px;
                            margin-top: 15px;
                            .jobLiCom{
                                color: #333333;
                                font-size: 14px;
                                font-weight: 400;
                                line-height: 14px;
                                padding-right: 13px;
                                border-right: 1px solid #E5E5E5;
                                float: left;
                                box-sizing: border-box;
                            }
                            .jobLiLoca{
                                width: 12px;
                                height: 14px;
                                float: left;
                                margin-left: 10px;
                                margin-right: 5px;
                            }
                            .jobLiCity{
                                font-size: 14px;
                                color: #999999;
                                float: left;
                                line-height: 14px;
                            }
                        }
                    }
                    .jobListLi:nth-child(3n){
                        margin-right: 0;
                    }
                }
            }
            .companyList{
                width: 100%;
                height: auto;
                overflow: hidden;
                .companyListLi{
                    width: 224px;
                    height: 208px;
                    background: #fff;
                    padding: 30px;
                    margin-right: 20px;
                    margin-bottom: 32px;
                    box-sizing: border-box;
                    float: left;
                    cursor: pointer;
                    overflow: hidden;
                    border: 1px solid rgba(204, 204, 204, 0.3);
                    .companyListLiImg{
                        width: 90px;
                        height: 90px;
                        border: 1px solid #E3E3E3;
                        margin: 0 auto;
                        display: block;
                    }
                    .companyListLiName{
                        font-size: 18px;
                        color: #333333;
                        text-align: center;
                        display: block;
                        line-height: 37px;
                        margin-top: 10px;
                    }
                    .companyListLiNum{
                        font-size: 14px;
                        color: #999999;
                        text-align: center;
                        display: block;
                        line-height: 16px;
                    }
                }
                .companyListLi:nth-child(5n){
                    margin-right: 0;
                }
            }
            .partnerList{
                width: 100%;
                height: auto;
                overflow: hidden;
                .partnerListLi{
                    width: 280px;
                    height: 300px;
                    overflow: hidden;
                    background: #fff;
                    margin-right: 26px;
                    padding: 30px 0;
                    border: 1px solid rgba(204, 204, 204, 0.5);
                    box-sizing: border-box;
                    float: left;
                    margin-bottom: 30px;
                    span{
                        .codeImg{
                            width: 170px;
                            height: 170px;
                            margin: 0 auto;
                            display: block;
                            background: #fff;
                            margin-top: 32px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }
                        .codeWechat{
                            font-size: 14px;
                            text-align: center;
                            font-weight: 400;
                            color: #999999;
                            line-height: 42px;
                        }
                        .partnerListLiImg{
                            width: 80px;
                            height: 80px;
                            display: block;
                            margin: 0 auto;
                        }
                        .partnerOne{
                            font-size: 18px;
                            font-weight: 400;
                            color: #333333;
                            display: block;
                            text-align: center;
                            line-height: 24px;
                            margin-top: 15px;
                        }
                        .partnerTwo{
                            display: block;
                            text-align: center;
                            font-size: 14px;
                            
                            font-weight: 400;
                            color: #666;
                            line-height: 20px;
                            margin-top: 5px;
                        }
                        .partnerThree{
                            display: block;
                            text-align: center;
                            font-size: 14px;
                            
                            font-weight: 400;
                            color: #1D5EEA;
                            line-height: 20px;
                            margin-top: 5px;
                        }
                        .partnerFour{
                            width: 100%;
                            height: 44px;
                            display: block;
                            margin-top: 25px;
                            .numLi{
                                width: 50%;
                                border-right: 1px dashed #CCCCCC;
                                box-sizing: border-box;
                                float: left;
                                display: block;
                                height: 44px;
                                span:first-child{
                                    font-size: 20px;
                                    
                                    font-weight: 400;
                                    color: #333333;
                                    line-height: 24px;
                                    display: block;
                                    text-align: center;
                                }
                                span:last-child{
                                    font-size: 14px;
                                    display: block;
                                    text-align: center;
                                    
                                    font-weight: 400;
                                    color: #999999;
                                    line-height: 24px;
                                }
                            }
                            .numLi:last-child{
                                border-right: 0;
                            }
                        }
                    }
                }
                .partnerListLi:nth-child(4n){
                    margin-right: 0;
                }
            }
            .talentsList{
                width: 100%;
                height: auto;
                overflow: hidden;
                .talentsListLi{
                    width: 280px;
                    height: 130px;
                    background: #FFFEFF;
                    float: left;
                    border: 1px solid rgba(204, 204, 204, 0.5);
                    overflow: hidden;
                    float: left;
                    margin-right: 25px;
                    box-sizing: border-box;
                    margin-bottom: 30px;
                    padding: 30px;
                    .talentsListLiImg{
                        width: 70px;
                        height: 70px;
                        border-radius: 50%;
                        display: block;
                        margin-right: 18px;
                        float: left;
                    }
                    .talentsRight{
                        float: left;
                        width: auto;
                        display: block;
                        height: 70px;
                        overflow: hidden;
                        .talentsListLiName{
                            display: block;
                            font-size: 18px;
                            
                            font-weight: 400;
                            line-height: 35px;
                            color: #222222;
                        }
                        .talentsListLiNum{
                            line-height: 35px;
                            display: block;
                            font-size: 14px;
                            
                            font-weight: 400;
                            color: #666666;
                        }
                    }
                }
                .talentsListLi:nth-child(4n){
                    margin-right: 0;
                }
            }
        }
        
        .seeMore{
            width: 300px;
            height:40px;
            font-size:18px;
            font-weight:400;
            color:#fff;
            line-height: 40px;
            text-align: center;
            margin: 0 auto;
            cursor: pointer;
            background: #1D5EEA;
            border: 1px solid #1D5EEA;
        }
        .moreBottom{
            margin-bottom: 100px;
        }
    }
    
</style>